import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CriticalSpareService extends Service {
	constructor(injector: Injector) {
		super("CriticalSpare", injector);
	}

	forMachineId(machineId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForMachine/${machineId}`);
	}

	forProductionToolId(machineId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForProductionTool/${machineId}`);
	}
}